/* ══════════════════════════════════════════════════════════════════════════════════════════════════
   MNL — GRILLE DE PRIX. UNE SEULE. V1259 — 06/08/2026.
   ══════════════════════════════════════════════════════════════════════════════════════════════════

   CE FICHIER EST LA SOURCE UNIQUE DES PRIX AFFICHÉS. Deux tables les portaient :
       PRICE_GRID    (assets/preworkout-configurator-v2.js)  — 11 formats × 5 paliers
       MNL_AI_PRICES (assets/mnl-ai-coach.js.liquid)         — 10 comptes de doses × 3 paliers
   La seconde était une COPIE MANUELLE de la première, tenue par un commentaire : « Les prix sont
   COPIÉS de PRICE_GRID […]. Si un prix change là-bas, il DOIT changer ici. » C'est exactement le
   contrat « miroir exact de PALIERS » qui a produit les défauts V1255 et V1256 sur les doses :
   personne ne fait respecter un commentaire, et une divergence de prix ne se voit pas — les deux
   surfaces ne s'affichent jamais côte à côte.

   POURQUOI UN FICHIER À PART PLUTÔT QUE « le Coach lit le configurateur » : sur la page
   /pages/preworkout-quiz, le Coach tourne SANS le configurateur (templates/page.preworkout-quiz.json
   ne charge que la section preworkout-quiz-ai). Faire lire l'un par l'autre n'aurait donc marché que
   sur la fiche produit — c'est-à-dire nulle part où ça compte. Ce fichier est chargé globalement par
   sections/header.liquid, avant les deux.

   ⚠ AUCUNE VALEUR N'A CHANGÉ EN V1259. Les 30 prix que le Coach dérive désormais d'ici ont été
     comparés un à un à ceux de son ancienne table : identiques. Le banc V1259 refait la comparaison.
   ⚠ NE JAMAIS écrire un prix ailleurs qu'ici. Une variante Shopify, elle, reste pilotée par les SKU
     (MNL-PW-…-{D|DP|E|EP|H}) : ce fichier dit ce que le client LIT, pas ce que Shopify facture — les
     deux doivent coïncider, et c'est le rôle du contrôle de variante du configurateur.
   ══════════════════════════════════════════════════════════════════════════════════════════════════ */
(function (root, factory) {
  var api = factory();
  try { root.MNL_PRICES = api; } catch (_) {}
  try { if (typeof module === 'object' && module.exports) module.exports = api; } catch (_) {}
}(typeof globalThis !== 'undefined' ? globalThis : (typeof window !== 'undefined' ? window : this), function () {
  'use strict';

  /* V1194 (fondateur) : grille passée de 3 à 5 PALIERS par format — le prix suit les sliders plus finement.
     Les 3 ancres historiques (V1075) sont INCHANGÉES (low/medium/high) ; on intercale « Doux + » (lowplus)
     et « Équilibré + » (mediumplus), adossés à 6 nouvelles variantes Shopify (SKU …-DP / …-EP).
     En parcours Auto (3 boutons), seuls low/medium/high restent atteignables → prix affichés identiques à avant.
     V1195 (fondateur) : curseur de doses 15→60 pas de 5 — 7 comptes intermédiaires INTERPOLÉS entre les
     ancres (marge dégressive avec le volume, jamais sous les niveaux audités ; prix/dose strictement
     décroissant sur chaque palier ; terminaisons ,95). */
  /* ═══ V1411 (audit rentabilité 24/08/2026, coûts matières RÉELS des journaux de fabrication) ═══
     Deux corrections, validées sur les 22 fabrications journalisées :
     1. La MOITIÉ HAUTE de la courbe (40→60 doses) était sous le coût réel : un 60 doses coûte
        32,76 € de matières en médiane (pas ~20), un 45 doses 24,62 €. Montée progressive
        +1/+2/+3/+4/+5 € (40/45/50/55/60 d) sur chaque palier — la contrainte « prix/dose
        STRICTEMENT décroissant sur chaque palier » est préservée (un +3 sec sur le seul 45d
        l'aurait cassée face au 40d).
     2. « Équilibré + » ≤ 30 doses facturait +2 € pour ~+6 € de matières réelles (ce palier
        monte le glycérol 41 €/kg et la théanine 128 €/kg) : mediumplus +2 € sur 15-30 doses,
        en restant sous high (l'ordre des paliers est un axe d'INTENSITÉ, il reste croissant).
     Ancres inchangées : TOUS les prix Doux/Équilibré/Hardcore de 15 à 35 doses — les « dès
     24,95 / 39,95 € » du Coach et des pages restent vrais. Shopify (SKU …-{D|DP|E|EP|H}) est
     aligné le même jour — les 29 variantes touchées. */
  var GRID = {
    starter:  { low: 24.95, lowplus: 26.95, medium: 29.95, mediumplus: 33.95, high: 34.95 },
    d20:      { low: 29.95, lowplus: 31.95, medium: 34.95, mediumplus: 38.95, high: 39.95 },
    d25:      { low: 34.95, lowplus: 36.95, medium: 39.95, mediumplus: 43.95, high: 44.95 },
    standard: { low: 39.95, lowplus: 41.95, medium: 44.95, mediumplus: 48.95, high: 49.95 },
    d35:      { low: 43.95, lowplus: 46.95, medium: 49.95, mediumplus: 52.95, high: 55.95 },
    d40:      { low: 48.95, lowplus: 52.95, medium: 55.95, mediumplus: 59.95, high: 62.95 },
    d45:      { low: 54.95, lowplus: 58.95, medium: 61.95, mediumplus: 66.95, high: 69.95 },
    d50:      { low: 59.95, lowplus: 64.95, medium: 67.95, mediumplus: 73.95, high: 76.95 },
    d55:      { low: 64.95, lowplus: 69.95, medium: 73.95, mediumplus: 80.95, high: 83.95 },
    pro:      { low: 69.95, lowplus: 74.95, medium: 79.95, mediumplus: 84.95, high: 89.95 }
  };

  /* V1195 : le « format » est un COMPTE DE DOSES. Ces trois tables sont réciproques ; elles vivent ici
     pour que le Coach n'ait pas à les recopier non plus (il en avait sa propre version, MNL_AI_DOSE_STEPS). */
  var DOSES_PER_FORMAT = { starter: 15, d20: 20, d25: 25, standard: 30, d35: 35, d40: 40, d45: 45, d50: 50, d55: 55, pro: 60 };
  var FMT_BY_DOSES     = { 15: 'starter', 20: 'd20', 25: 'd25', 30: 'standard', 35: 'd35', 40: 'd40', 45: 'd45', 50: 'd50', 55: 'd55', 60: 'pro' };
  var DOSE_STEPS       = [15, 20, 25, 30, 35, 40, 45, 50, 55, 60];

  var recipeTiers = {};
  var source = 'reference';
  function hydrate(payload) {
    var next = {}, count = 0;
    var tiers = { D:'low', DP:'lowplus', E:'medium', EP:'mediumplus', H:'high' };
    var formats = { SS:'starter', S:'standard', P:'pro' };
    if (!payload || !Array.isArray(payload.variants)) throw new Error('MNL pricing: missing Shopify variants');
    payload.variants.forEach(function (variant) {
      var match = String(variant.sku || '').match(/^MNL-PW-(?:30-(SS|S|P)|DOSES-(20|25|35|40|45|50|55))-(D|DP|E|EP|H)$/);
      if (!match) return;
      var fmt = match[1] ? formats[match[1]] : FMT_BY_DOSES[Number(match[2])];
      var tier = tiers[match[3]], cents = Number(variant.priceCents);
      if (!Number.isSafeInteger(cents) || cents <= 0) throw new Error('MNL pricing: invalid variant price');
      if (!next[fmt]) next[fmt] = {};
      if (next[fmt][tier] !== undefined) throw new Error('MNL pricing: duplicate variant tier');
      next[fmt][tier] = cents / 100;
      count++;
    });
    if (count !== DOSE_STEPS.length * 5) throw new Error('MNL pricing: incomplete Shopify grid');
    Object.keys(GRID).forEach(function (fmt) {
      Object.keys(GRID[fmt]).forEach(function (tier) {
        if (!next[fmt] || !Number.isFinite(next[fmt][tier])) throw new Error('MNL pricing: missing tier');
      });
    });
    Object.keys(next).forEach(function (fmt) {
      Object.keys(next[fmt]).forEach(function (tier) { GRID[fmt][tier] = next[fmt][tier]; });
    });
    Object.keys(payload.recipeTiers || {}).forEach(function (key) {
      var tier = payload.recipeTiers[key];
      if (['low','medium','high'].indexOf(tier) !== -1) recipeTiers[key] = tier;
    });
    source = 'shopify';
  }
  if (typeof document !== 'undefined') {
    var bootstrap = document.getElementById('mnl-shopify-prices');
    if (!bootstrap) throw new Error('MNL pricing: Shopify bootstrap unavailable');
    hydrate(JSON.parse(bootstrap.textContent));
  }

  /* Le Coach n'atteint que trois paliers et les nomme en français. Une seule table de correspondance,
     ici, plutôt qu'une par surface. */
  var PALIER_BY_LABEL = { 'Doux': 'low', 'Équilibré': 'medium', 'Equilibré': 'medium', 'Hardcore': 'high', 'Intense': 'high' };

  /* Prix d'un couple (compte de doses, palier). `palier` accepte la clé interne ('low') ou le libellé
     du Coach ('Doux'). Repli : 30 doses / medium, comme les deux surfaces le faisaient déjà. */
  function priceFor(doses, palier) {
    var fmt = FMT_BY_DOSES[Number(doses)] || 'standard';
    var row = GRID[fmt] || GRID.standard;
    var key = PALIER_BY_LABEL[palier] || palier;
    var v = row[key];
    return (typeof v === 'number') ? v : row.medium;
  }

  /* Vue « à la manière du Coach » : { 15: {Doux, Équilibré, Hardcore}, … }. DÉRIVÉE, jamais écrite —
     c'est ce qui remplace MNL_AI_PRICES. */
  function coachTable() {
    var out = {};
    DOSE_STEPS.forEach(function (n) {
      out[n] = { 'Doux': priceFor(n, 'low'), 'Équilibré': priceFor(n, 'medium'), 'Hardcore': priceFor(n, 'high') };
    });
    return out;
  }

  /* Empreinte calculée SUR LA TABLE, à l'exécution — même geste que MNL_DOSES.FINGERPRINT : deux pages
     qui n'affichent pas la même chaîne ne vendent pas au même prix, et ça se voit depuis une console. */
  function fingerprint() {
    var s = 'V1502|';
    Object.keys(GRID).forEach(function (f) {
      s += f + ':' + ['low', 'lowplus', 'medium', 'mediumplus', 'high'].map(function (p) { return GRID[f][p]; }).join(',') + '|';
    });
    var h = 5381;
    for (var i = 0; i < s.length; i++) { h = ((h * 33) ^ s.charCodeAt(i)) >>> 0; }
    return 'MNLP-' + ('0000000' + h.toString(16)).slice(-8) + '-' + s.length;
  }

  function selfTest() {
    var cas = source === 'reference' ? [
      ['Standard / Équilibré = 44,95', priceFor(30, 'Équilibré'), 44.95],
      ['Starter / Doux = 24,95', priceFor(15, 'Doux'), 24.95],
      ['Pro / Hardcore = 89,95 (V1411)', priceFor(60, 'Hardcore'), 89.95],
      ['45 doses / Équilibré = 61,95 (V1411)', priceFor(45, 'Équilibré'), 61.95],
      ['prix/dose décroissant (30 vs 60, medium)', priceFor(60, 'medium') / 60 < priceFor(30, 'medium') / 30, true],
      ['compte inconnu → Standard', priceFor(999, 'medium'), 44.95],
      ['palier inconnu → medium', priceFor(30, 'n_importe_quoi'), 44.95]
    ] : [
      ['Shopify grid has 50 prices', Object.keys(GRID).reduce(function (n, fmt) { return n + Object.keys(GRID[fmt]).length; }, 0), 50],
      ['Shopify prices are positive cents', Object.keys(GRID).every(function (fmt) { return Object.keys(GRID[fmt]).every(function (tier) { var p = GRID[fmt][tier]; return p > 0 && Math.abs(p * 100 - Math.round(p * 100)) < 0.00001; }); }), true],
      ['Unknown dose falls back to standard', priceFor(999, 'medium'), GRID.standard.medium],
      ['Unknown tier falls back to medium', priceFor(30, 'n_importe_quoi'), GRID.standard.medium]
    ];
    var ko = cas.filter(function (c) { return c[1] !== c[2]; });
    return { ok: ko.length === 0, total: cas.length, echecs: ko, cas: cas, empreinte: fingerprint() };
  }

  return {
    VERSION: 'V1502',
    DATE: '2026-09-08',
    SOURCE: source,
    RECIPE_TIERS: recipeTiers,
    GRID: GRID,
    DOSES_PER_FORMAT: DOSES_PER_FORMAT,
    FMT_BY_DOSES: FMT_BY_DOSES,
    DOSE_STEPS: DOSE_STEPS,
    PALIER_BY_LABEL: PALIER_BY_LABEL,
    priceFor: priceFor,
    coachTable: coachTable,
    FINGERPRINT: fingerprint(),
    fingerprint: fingerprint,
    selfTest: selfTest
  };
}));
